<template>
  <div>
    <LoadingSpinner :loading="loading" :text="loadingText" />
    <b-row v-if="!loading">
      <b-col cols="12" class="my-3">
        {{ $lang.select_term_attachment_label }}
      </b-col>
      <b-col cols="9" md="8">
        <b-form-group>
          <selectFind
            :options="attachmentOptions"
            v-model="attachmentType"
            label="caption"
            id="id"
            :loading="attachmentTypeLoading"
          />
        </b-form-group>
      </b-col>
      <b-col cols="2" md="auto">
        <b-button variant="secondary" @click="add()">
          <mdicon name="plus" size="24" />
        </b-button>
      </b-col>
      <b-col cols="12" md="9" v-for="(item, index) in items" :key="index">
        <div class="border rounded p-3 mb-3">
          <div class="d-flex align-self-center justify-content-between">
            <span>{{ item.caption }}</span>
            <b-form-group label-cols="" :label="$lang.required" class="m-0">
              <b-form-checkbox
                v-model="item.isRequired"
                name="check-button"
                switch
                class="m-0 mt-2"
              />
            </b-form-group>
          </div>
          <div class="text-muted mb-2">{{ $lang.max_upload_size_label }}</div>
          <b-form-input
            v-model="item.maxUpload"
            type="number"
            autocomplete="off"
            @input="checkMaxUpload(item)"
          />
          <div class="text-right mt-3">
            <b-button variant="outline-danger" @click="remove(item)">{{
              $lang.delete
            }}</b-button>
          </div>
        </div>
      </b-col>
      <b-col cols="12" class="mt-3 text-right">
        <b-button variant="success" @click="submit">
          <mdicon name="check" size="20" />
          {{ $lang.submitButton }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { pathOr } from "ramda";
import { generateApiUrl, renderEumOptions } from "@/shared/utils";

export default {
  components: { LoadingSpinner },
  props: {
    parentItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      code: this.$route.params.code,
      loading: false,
      loadingText: this.$lang.receiving_data,
      attachmentType: null,
      attachmentTypeLoading: false,
      isRequired: false,
      items: [],
    };
  },
  computed: {
    attachmentOptions() {
      return renderEumOptions("attachment_type_person", true);
    },
  },
  watch: {
    parentItems: {
      immediate: true,
      handler(value) {
        value && this.fetchData();
      },
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    renderEumOptions,
    add() {
      if (!this.attachmentType) {
        return this.$notify.warning(this.$lang.please_select_one_option);
      }
      const id = pathOr(null, ["id"], this.attachmentType);
      const caption = pathOr(null, ["caption"], this.attachmentType);

      const alreadySelected = !!this.items.some((item) => item.id === id);
      if (alreadySelected) {
        return this.$notify.warning(`گزینه ${caption} قبلا ایحاد شده است`);
      }

      const newItem = {
        id,
        caption,
        isRequired: true,
        maxUpload: 1,
      };
      this.items = [newItem, ...this.items];
    },
    remove(data) {
      this.items = this.items.filter((item) => item.id !== data.id);
    },
    checkMaxUpload(item) {
      const { maxUpload } = item;
      const min = 1;
      const max = 100;
      if (
        !maxUpload ||
        maxUpload.length > 3 ||
        +maxUpload < 1 ||
        +maxUpload > 100
      ) {
        item.maxUpload = 1;
        return this.$notify.warning(
          "حداکثر مجاز برای بارگذاری بین 1 تا 100 می باشد"
        );
      }
    },
    async submit() {
      if (!this.items.length) {
        return this.$notify.warning(this.$lang.please_select_one_record);
      }
      try {
        this.loadingText = this.$lang.sending_data;
        this.loading = true;
        const url = generateApiUrl(
          ["profile", "term_extra_attachment"],
          [this.code]
        );
        const payload = {
          attachment: [
            ...this.items.map((item) => {
              return {
                id: pathOr(null, ["id"], item),
                is_required: pathOr(false, ["isRequired"], item),
                max_upload: pathOr(1, ["maxUpload"], item),
              };
            }),
          ],
        };
        const response = await this.$httpService.put(url, payload);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    async fetchData() {
      try {
        this.loadingText = this.$lang.receiving_data;
        this.loading = true;
        this.items = this.parentItems.map((item) => {
          const attachment = this.attachmentOptions.find(
            (attachment) => attachment.id === item.id
          );
          const maxUpload = pathOr(1, ["max_upload"], item);
          return {
            id: pathOr(null, ["id"], attachment),
            caption: pathOr("", ["caption"], attachment),
            isRequired: pathOr(false, ["is_required"], item),
            maxUpload,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
